export const cloudApi = "https://api.la.devsquadx-cloud.com";

export const api =
  process.env.NODE_ENV === "development" ? "http://localhost:1337" : cloudApi;

export const frontUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : "https://la.devsquadx-cloud.com";
